<template>
  <v-alert
    v-if="show"
    :type="alertType"
    prominent
    border="left"
    colored-border
    class="mb-4"
  >
    <strong>{{ title }}</strong>
    {{ message }}
    <template v-if="showAction">
      <v-btn
        class="mt-2"
        small
        color="#e5183d"
        dark
        @click="$emit('renew')"
      >
        {{ actionLabel }}
      </v-btn>
    </template>
  </v-alert>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "PremiumRenewalAlert",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    expired: {
      type: Boolean,
      default: false,
    },
    daysUntilExpiry: {
      type: Number,
      default: null,
    },
    expiresAt: {
      type: String,
      default: null,
    },
    showAction: {
      type: Boolean,
      default: true,
    },
  },
  emits: ["renew"],
  computed: {
    alertType(): string {
      return this.expired ? "error" : "warning";
    },
    title(): string {
      if (this.expired) {
        return "Assinatura Premium expirada.";
      }
      return "Renovação Premium em breve.";
    },
    message(): string {
      if (this.expired) {
        return " Sua assinatura anual venceu. Renove para continuar recebendo comissões da rede.";
      }

      if (this.daysUntilExpiry === 1) {
        return " Sua assinatura anual vence amanhã. Renove para não perder os benefícios Premium.";
      }

      if (typeof this.daysUntilExpiry === "number" && this.daysUntilExpiry > 0) {
        return ` Sua assinatura anual vence em ${this.daysUntilExpiry} dias. Renove para manter os benefícios Premium.`;
      }

      if (this.expiresAt) {
        return ` Sua assinatura anual vence em ${this.formatDate(this.expiresAt)}.`;
      }

      return " Sua assinatura anual está próxima do vencimento.";
    },
    actionLabel(): string {
      return this.expired ? "Renovar Premium" : "Renovar agora";
    },
  },
  methods: {
    formatDate(value: string): string {
      return new Intl.DateTimeFormat("pt-BR", { dateStyle: "long" }).format(
        new Date(value),
      );
    },
  },
});
</script>
